
import { UnitsBulkAssignView, UnitsReservationView  , ContactProfileManagementView} from '../../Views/Home';

import {  
  UnitsLeaseLeadOwner , 
  UnitsLeaseManagementView,
  UnitsLeaseStatusManagementView,
  UnitsLeaseProfileManagementView  } from '../../Views/Home/UnitsLeaseLeadOwnerView' ; 


export const LeadOwnerUnitLeaseRoutes = [
  {
    path: '/add',
    name: 'homeLayout.unitsManagementView.units-management-view',
    component: UnitsLeaseManagementView,
    layout: '/home/lead-owner-units-lease',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'UnitsView:lease-units',
        isDisabled: false,
        route: '/home/lead-owner-units-lease/view',
        groupName: 'lead-owner',
      },
      {
        name: 'homeLayout.unitsManagementView.units-management-view',
        isDisabled: true,
        route: '/home/lead-owner-units-lease/add',
      },
    ],
  },
  {
    path: '/edit',
    name: 'homeLayout.unitsManagementView.units-management-view',
    component: UnitsLeaseManagementView,
    layout: '/home/lead-owner-units-lease',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'UnitsView:lease-units',
        isDisabled: false,
        route: '/home/lead-owner-units-lease/view',
        groupName: 'lead-owner',
      },
      {
        name: 'homeLayout.unitsManagementView.units-management-view',
        isDisabled: true,
        route: '/home/lead-owner-units-lease/edit',
      },
    ],
  },
  {
    path: '/unit-profile-edit',
    name: 'UnitsProfileManagementView:unit-profile-edit',
    component: UnitsLeaseProfileManagementView,
    layout: '/home/lead-owner-units-lease',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'unitsView:lease-units',
        isDisabled: false,
        route: '/home/lead-owner-units-lease/view',
        groupName: 'lead-owner',
      },
      {
        name: 'UnitsProfileManagementView:unit-profile-edit',
        isDisabled: true,
        route: '/home/lead-owner-units-lease/unit-profile-edit',
      },
    ],
  },
  {
    path: '/unit-status-management',
    name: 'UnitsStatusManagementView:unit-status-management',
    component: UnitsLeaseStatusManagementView,
    layout: '/home/lead-owner-units-lease',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'unitsView:lease-units',
        isDisabled: false,
        route: '/home/lead-owner-units-lease/view',
        groupName: 'lead-owner',
      },
      {
        name: 'UnitsStatusManagementView:unit-status-management',
        isDisabled: true,
        route: '/home/lead-owner-units-lease/unit-status-management',
      },
    ],
  },
  {
    path: '/view',
    name: 'UnitsView:lease-units',
    component: UnitsLeaseLeadOwner,
    layout: '/home/lead-owner-units-lease',
    default: true,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'UnitsView:lease-units',
        isDisabled: false,
        route: '/home/lead-owner-units-lease/view',
        groupName: 'lead-owner',
      },
    ],
  },
  {
    path: '/unit-profile-reservation',
    name: 'UnitsProfileManagementView:unit-profile-reservation',
    component: UnitsReservationView,
    layout: '/home/lead-owner-units-lease',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'unitsView:lease-units',
        isDisabled: false,
        route: '/home/lead-owner-units-lease/view',
        groupName: 'lead-owner',
      },
      {
        name: 'UnitsProfileManagementView:unit-profile-reservation',
        isDisabled: true,
        route: '/home/lead-owner-units-lease/unit-profile-reservation',
      },
    ],
  },
  {
    path: '/unit-bulk-update',
    name: 'UnitsProfileManagementView:unit-bulk-update',
    component: UnitsBulkAssignView,
    layout: '/home/lead-owner-units-lease',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'unitsView:lease-units',
        isDisabled: false,
        route: '/home/lead-owner-units-lease/view',
        groupName: 'lead-owner',
      },
      {
        name: 'UnitsProfileManagementView:unit-bulk-update',
        isDisabled: true,
        route: '/home/lead-owner-units-lease/unit-bulk-update',
      },
    ],
  },
  {
    path: '/contact-edit',
    name: 'ContactProfileManagementView:contact-profile-edit',
    component: ContactProfileManagementView,
    layout: '/home/units-lease',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'unitsView:lease-units',
        isDisabled: false,
        route: '/home/lead-owner-units-lease/view',
        groupName: 'lead-owner',
      },
      {
        name: 'ContactProfileManagementView:contact-profile-edit',
        isDisabled: true,
        route: '/home/lead-owner-units-lease/contact-edit',
      },
    ],
  },
];

